import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField, styled } from '@mui/material';

const StyledTextField = styled(TextField)(() => ({
    '& .MuiInputLabel-asterisk': {
        color: 'red',
    },
}));

// ----------------------------------------------------------------------

RHFTextField.propTypes = {
    name: PropTypes.string,
    disabled: PropTypes.bool,
};

export default function RHFTextField({ name, disabled, helperText, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <StyledTextField
                    {...field}
                    noValidate
                    fullWidth
                    error={!!error}
                    disabled={disabled}
                    sx={{ backgroundColor: disabled ? 'lightgrey' : 'inherit' }}
                    helperText={error?.message || helperText}
                    {...other}
                />
            )}
        />
    );
}
